import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { usePlanCompleto } from '../plan-completo-store';

/** La pantalla de inicio de la prueba: la de la misión 1, donde aterriza la invitación. */
export const INICIO_DE_LA_DEMO = '/compite/monitoreo';

/**
 * Mini Prixia (X1, decisión 24): una dirección que la prueba no incluye (escrita a
 * mano o de un marcador) no deja una página muerta: vuelve al inicio de la prueba
 * con el cuadro del plan completo abierto, igual que tocar esa entrada del menú.
 */
export function VolverConElPlanCompleto() {
  const abrir = usePlanCompleto((s) => s.abrir);
  useEffect(() => {
    abrir();
  }, [abrir]);
  return <Navigate to={INICIO_DE_LA_DEMO} replace />;
}
